import { render, staticRenderFns } from "./PolicyButtons.vue?vue&type=template&id=a4436808&"
import script from "./PolicyButtons.vue?vue&type=script&lang=js&"
export * from "./PolicyButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4436808')) {
      api.createRecord('a4436808', component.options)
    } else {
      api.reload('a4436808', component.options)
    }
    module.hot.accept("./PolicyButtons.vue?vue&type=template&id=a4436808&", function () {
      api.rerender('a4436808', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/hotels/hotel/PolicyButtons.vue"
export default component.exports